var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "login bg-iw-background text-iw-on-background min-h-screen flex font-body",
    class: {
      'login-auth-page': !_vm.isLogin,
      'login-unit-page': _vm.isLogin,
      'login-mfa-pending': _vm.isMfaPending
    }
  }, [!_vm.isLogin ? _c('aside', {
    staticClass: "login-brand-panel hidden lg:flex w-[400px] flex-shrink-0 flex-col justify-between py-16 px-12 relative",
    staticStyle: {
      "background-color": "#1a2035",
      "width": "400px",
      "height": "100vh",
      "flex-shrink": "0",
      "padding": "64px 48px",
      "overflow-x": "hidden",
      "overflow-y": "auto",
      "box-sizing": "border-box"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "absolute top-0 right-0 w-[1px] h-full bg-gradient-to-b from-transparent via-white/10 to-transparent"
  }), _vm._m(1), _vm._m(2), _c('div', {
    staticClass: "relative z-10"
  }, [_vm._m(3), _c('p', {
    staticClass: "font-label text-[10px] text-white/15"
  }, [_vm._v(" © " + _vm._s(new Date().getFullYear()) + ` ${$t("78a1spc", "杭州绿云软件股份有限公司")} `)])])]) : _vm._e(), _c('main', {
    staticClass: "flex-1 flex flex-col min-h-screen bg-iw-background",
    class: {
      'login-auth-main-scroll': !_vm.isLogin
    }
  }, [!_vm.isLogin ? [_c('header', {
    staticClass: "flex justify-between items-center px-10 py-5 border-b border-stone-100"
  }, [_vm._m(4), _c('div', {
    staticClass: "flex items-center space-x-6 ml-auto"
  }, [_c('FootLanguage')], 1)]), _c('div', {
    staticClass: "flex-1 flex items-start lg:items-center justify-center px-4 lg:px-8 py-8 lg:py-16"
  }, [_c('div', {
    staticClass: "w-full max-w-md login-form-shell"
  }, [_c('div', {
    staticClass: "login-form-body",
    class: {
      'login-form-body--wechat': _vm._wxQuickLogin
    }
  }, [!_vm._wxQuickLogin ? _c('LoginMain', {
    attrs: {
      "login": _vm.login
    },
    on: {
      "on-change": _vm.handleChange,
      "no-mobile-email": _vm.noMobileEmail,
      "on-login-wx": _vm.getUnits,
      "on-submit-mobile-password": _vm.handleSubmit,
      "on-submit-mobile-code": _vm.handleSubmitWithPhone,
      "on-submit-email-password": _vm.handleSubmit,
      "on-submit-email-code": _vm.handleSubmitWithEmail
    }
  }) : _c('div', {
    staticClass: "login-form-body__wechat"
  }, [_c('WechatQuickLogin', {
    attrs: {
      "sendMessage": _vm.sendMessage,
      "login": _vm.login
    },
    on: {
      "saved-login": _vm.savedLogin,
      "on-change": _vm.handleChange
    }
  }), _c('QRCODE', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    ref: "qrcode",
    attrs: {
      "check": !_vm.showSavedLogin
    },
    on: {
      "login": _vm.getUnits,
      "logout": function ($event) {
        _vm.login.showEWM = true;
      }
    }
  })], 1)], 1), _c('div', {
    staticClass: "login-form-actions flex items-center justify-between font-label text-xs"
  }, [_c('span', {
    staticClass: "text-iw-on-surface-variant hover:text-iw-secondary cursor-pointer transition-colors",
    on: {
      "click": function ($event) {
        return _vm.goToOther('Regist');
      }
    }
  }, [_vm._v(` ${$t("fub0ks4", "立即注册")} `)]), _c('span', {
    staticClass: "text-iw-on-surface-variant hover:text-iw-secondary cursor-pointer transition-colors",
    on: {
      "click": function ($event) {
        return _vm.goToOther('Forget');
      }
    }
  }, [_vm._v(` ${$t("co3ob74", "忘记密码")} `)])]), _c('p', {
    staticClass: "login-form-note mt-10 font-label text-xs text-iw-on-surface-variant text-center leading-relaxed whitespace-pre-line"
  }, [_vm._v(` ${$t("2ud2o916", "iWork 仅对杭州绿云软件股份有限公司授权成员开放。 未经授权的访问行为将被记录。")} `)])])]), _vm._m(5)] : [_c('header', {
    staticClass: "sticky top-0 z-50 flex items-center justify-between px-8 h-14 flex-shrink-0",
    staticStyle: {
      "background-color": "#1a2035"
    }
  }, [_vm._m(6), _c('div', {
    staticClass: "flex items-center space-x-1"
  }, [_c('FootLanguage', {
    staticClass: "switch-unit-lang"
  })], 1)]), _c('div', {
    staticClass: "switch-unit-content flex-1 bg-iw-background"
  }, [_c('SwitchingUnit', {
    attrs: {
      "treeData": _vm.unitTreeDate,
      "loading": _vm.switchUnitLoading
    },
    on: {
      "onLogout": _vm.onLogout,
      "on-change-unit": _vm.onClickGoUnit
    }
  })], 1)]], 2), _c('SecondCheck', {
    on: {
      "getUnits": _vm.getUnits
    }
  }), _c('Modal', {
    attrs: {
      "width": "300px",
      "title": "",
      "mask-closable": false
    },
    model: {
      value: _vm.showGZH,
      callback: function ($$v) {
        _vm.showGZH = $$v;
      },
      expression: "showGZH"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_vm._v(` ${$t("uedh1we", "微信搜索并关注绿云服务公众号")} `)]), _c('div', [_c('img', {
    attrs: {
      "src": "https://app-1251575231.cos.ap-shanghai.myqcloud.com/portal/icon/gzh.jpg"
    }
  })]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })]), _c('ValidMFA', {
    ref: "validMFA",
    attrs: {
      "unitName": _vm.currentUnit.name,
      "unitCode": _vm.currentUnit.code
    },
    on: {
      "validSuccess": function ($event) {
        return _vm.validSuccess();
      },
      "validCancel": _vm.validCancel
    }
  }), _c('Protection', {
    ref: "protection",
    attrs: {
      "closeable": false
    },
    on: {
      "validCancel": _vm.validCancel,
      "validSuccess": function ($event) {
        return _vm.validSuccess();
      }
    }
  }), _c('tipModal', {
    ref: "tipModal",
    attrs: {
      "unitName": _vm.currentUnit.name,
      "unitCode": _vm.currentUnit.code
    },
    on: {
      "cancel": _vm.cancel,
      "confirm": _vm.confirm
    }
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "absolute inset-0 opacity-[0.03]"
  }, [_c('div', {
    staticClass: "absolute top-0 left-0 w-full h-full",
    staticStyle: {
      "background-image": "repeating-linear-gradient(",
      "background-size": "24px 24px"
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "relative z-10"
  }, [_c('div', {
    staticClass: "flex items-center space-x-3 mb-16"
  }, [_c('div', {
    staticClass: "w-9 h-9 rounded-lg flex items-center justify-center",
    staticStyle: {
      "background-color": "#785a1a"
    }
  }, [_c('img', {
    staticClass: "w-[22px] h-[22px]",
    attrs: {
      "src": require("@/assets/iwork-logo.png"),
      "alt": "",
      "aria-hidden": "true"
    }
  })]), _c('span', {
    staticClass: "font-headline text-white text-2xl tracking-tight"
  }, [_vm._v("iWork")])]), _c('h1', {
    staticClass: "text-4xl font-headline text-white leading-snug mb-4"
  }, [_vm._v(` ${$t("ya5vrn5", "一站式工作")}`), _c('br'), _vm._v(`${$t("aucsqy4", "协作平台")} `)]), _c('p', {
    staticClass: "font-label text-[10px] text-white/30 tracking-[0.25em] mb-10"
  }, [_vm._v(` ${$t("78a1spc", "杭州绿云软件股份有限公司")} `)]), _c('p', {
    staticClass: "font-body text-sm text-white/40 leading-relaxed max-w-xs"
  }, [_vm._v(` ${$t("5ta8t629", "作为酒店数字化生态中枢，深度聚合绿云 PMS、Oracle Hospitality、数据与营销四大核心业务。基于统一身份认证，为全员提供高效、安全的专属工作入口。")} `)])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "relative z-10 space-y-3"
  }, [_c('p', {
    staticClass: "font-label text-[10px] text-white/30 tracking-widest mb-5"
  }, [_vm._v(` ${$t("p2xq3q5", "已接入应用")} `)]), _c('div', {
    staticClass: "flex items-center space-x-3"
  }, [_c('div', {
    staticClass: "w-8 h-8 rounded-lg flex items-center justify-center",
    staticStyle: {
      "background-color": "rgba(255, 255, 255, 0.06)"
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-white/40 text-sm"
  }, [_vm._v("hotel")])]), _c('div', [_c('p', {
    staticClass: "font-label text-xs text-white/70"
  }, [_vm._v($t("2hivd46", "绿云 PMS"))]), _c('p', {
    staticClass: "font-label text-[10px] text-white/30"
  }, [_vm._v($t("ta2jke6", "酒店管理系统"))])]), _c('span', {
    staticClass: "ml-auto w-1.5 h-1.5 rounded-full bg-iw-secondary iw-status-halo-active flex-shrink-0"
  })]), _c('div', {
    staticClass: "flex items-center space-x-3"
  }, [_c('div', {
    staticClass: "w-8 h-8 rounded-lg flex items-center justify-center",
    staticStyle: {
      "background-color": "rgba(255, 255, 255, 0.06)"
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-white/40 text-sm"
  }, [_vm._v("apartment")])]), _c('div', [_c('p', {
    staticClass: "font-label text-xs text-white/70"
  }, [_vm._v("Oracle Hospitality")]), _c('p', {
    staticClass: "font-label text-[10px] text-white/30"
  }, [_vm._v("OPERA for China")])]), _c('span', {
    staticClass: "ml-auto w-1.5 h-1.5 rounded-full bg-iw-secondary iw-status-halo-active flex-shrink-0"
  })]), _c('div', {
    staticClass: "flex items-center space-x-3"
  }, [_c('div', {
    staticClass: "w-8 h-8 rounded-lg flex items-center justify-center",
    staticStyle: {
      "background-color": "rgba(255, 255, 255, 0.06)"
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-white/40 text-sm"
  }, [_vm._v("bar_chart")])]), _c('div', [_c('p', {
    staticClass: "font-label text-xs text-white/70"
  }, [_vm._v($t("foirbh6", "绿云数据平台"))]), _c('p', {
    staticClass: "font-label text-[10px] text-white/30"
  }, [_vm._v($t("ow0szt7", "数据分析与决策"))])]), _c('span', {
    staticClass: "ml-auto w-1.5 h-1.5 rounded-full bg-iw-secondary iw-status-halo-active flex-shrink-0"
  })]), _c('div', {
    staticClass: "flex items-center space-x-3"
  }, [_c('div', {
    staticClass: "w-8 h-8 rounded-lg flex items-center justify-center",
    staticStyle: {
      "background-color": "rgba(255, 255, 255, 0.06)"
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-white/40 text-sm"
  }, [_vm._v("campaign")])]), _c('div', [_c('p', {
    staticClass: "font-label text-xs text-white/70"
  }, [_vm._v($t("q35b2w6", "数字营销中心"))]), _c('p', {
    staticClass: "font-label text-[10px] text-white/30"
  }, [_vm._v($t("5p24127", "营销自动化平台"))])]), _c('span', {
    staticClass: "ml-auto w-1.5 h-1.5 rounded-full bg-iw-secondary iw-status-halo-active flex-shrink-0"
  })]), _c('div', {
    staticClass: "pt-3 border-t border-white/5"
  }, [_c('p', {
    staticClass: "font-label text-[10px] text-white/20"
  }, [_vm._v(` ${$t("udxzb0d", "及其他 10+ 已接入应用")} `)])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex items-center space-x-2 mb-3"
  }, [_c('span', {
    staticClass: "w-1.5 h-1.5 rounded-full bg-iw-secondary iw-status-halo-active animate-pulse"
  }), _c('span', {
    staticClass: "font-label text-[10px] text-white/30 tracking-widest"
  }, [_vm._v($t("s0e17vc", "iWork 服务运行正常"))])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex items-center space-x-2.5 lg:hidden"
  }, [_c('div', {
    staticClass: "w-7 h-7 rounded-lg flex items-center justify-center",
    staticStyle: {
      "background-color": "#785a1a"
    }
  }, [_c('img', {
    staticClass: "w-[16px] h-[16px]",
    attrs: {
      "src": require("@/assets/iwork-logo.png"),
      "alt": "",
      "aria-hidden": "true"
    }
  })]), _c('span', {
    staticClass: "font-headline text-iw-on-surface text-lg"
  }, [_vm._v("iWork")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('footer', {
    staticClass: "login-auth-footer px-4 lg:px-10 py-5 border-t border-stone-100 text-center text-iw-on-surface-variant"
  }, [_c('div', {
    staticClass: "flex justify-center items-center text-[12px] mb-2 space-x-2"
  }, [_c('a', {
    staticClass: "hover:text-iw-secondary transition-colors",
    attrs: {
      "href": "https://www.ihotel.cn/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v($t("alt7ee4", "关于我们"))]), _c('span', [_vm._v("|")]), _c('a', {
    staticClass: "hover:text-iw-secondary transition-colors",
    attrs: {
      "href": "https://help.ihotel.cn/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v($t("c84ii94", "帮助中心"))])]), _c('div', {
    staticClass: "font-label text-[10px] mb-1"
  }, [_vm._v(` ${$t("5zr1qi1n", "浙ICP备11052993号-2 浙公网安备33010602007191号 Copyright © 2010-2026")} `)]), _c('div', {
    staticClass: "font-label text-[10px]"
  }, [_vm._v(" Hangzhou GreenCloud Tech Co., Ltd. All Rights Reserved. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex items-center space-x-2.5 flex-shrink-0"
  }, [_c('div', {
    staticClass: "w-8 h-8 rounded-lg flex items-center justify-center",
    staticStyle: {
      "background-color": "#785a1a"
    }
  }, [_c('img', {
    staticClass: "w-[20px] h-[20px]",
    attrs: {
      "src": require("@/assets/iwork-logo.png"),
      "alt": "",
      "aria-hidden": "true"
    }
  })]), _c('span', {
    staticClass: "font-headline text-white text-xl tracking-tight"
  }, [_vm._v("iWork")]), _c('div', {
    staticClass: "h-5 w-[1px] bg-white/15 ml-3"
  }), _c('span', {
    staticClass: "font-label text-[11px] tracking-[0.25em] text-white/40 uppercase ml-3"
  }, [_vm._v($t("wh8z6z7", "请选择您的单位"))])]);
}];
export { render, staticRenderFns };